import * as React from "react";
import { NGButton } from "../../../newcomponents/button/Button";
import { useFormContext } from "react-hook-form";
import { isEqual } from "lodash";
import { Domain } from "../../../schema/types/domain/entity";
import { DomainInput } from "./types/input";
import { domainToInput, getDefaultDomainInput, inputToDomain } from "./utils/utils";

interface Props {
  domain?: Domain;
}
export const CreateNGSaveCreate: React.FC<Props> = ({ domain }) => {
  const { watch } = useFormContext<DomainInput>();

  const allValues = watch();

  const isEdit = watch("isEdit");
  const isLoading = watch("isLoading");
  const dryRun = watch("dryRun.raw.value");
  const dryRunNameOnly = watch("dryRun.nameOnly.value");

  // const { initialBody, currentBody } = React.useMemo(() => {
  //   const initialInput = domain ? domainToInput(domain) : getDefaultDomainInput();
  //   const initialBody = inputToDomain(initialInput);
  //   const currentBody = inputToDomain(allValues);

  //   return { initialBody, currentBody };
  // }, [isEdit, allValues]);

  const isDirty = React.useMemo(() => {
    if (!isEdit) {
      return true;
    }

    const initialInput = domain ? domainToInput(domain) : getDefaultDomainInput();
    const initialBody = inputToDomain(initialInput);
    const currentBody = inputToDomain(allValues);

    return !isEqual(initialBody, currentBody);
  }, [isEdit, allValues]);

  return (
    <>
      {/* <div className="flex flex-col gap-4">
        <div className="flex gap-4 color-default" style={{ fontSize: 12 }}>
          <pre>
            {JSON.stringify({ first: dryRunNameOnly.status, second: dryRun.status, isDirty, isLoading }, null, 2)}
          </pre>
          <pre>{JSON.stringify(initialBody, null, 2)}</pre>
          <pre>{JSON.stringify(currentBody, null, 2)}</pre>
        </div>
      </div> */}
      <NGButton
        variant="primary"
        className="w-full"
        type={`submit`}
        disabled={
          dryRunNameOnly.status !== 200 ||
          (typeof dryRun.status === "number" && dryRun.status !== 200) ||
          !isDirty ||
          isLoading
        }
        loading={isLoading}
      >
        {isEdit ? "Save" : "Create Domain"}
      </NGButton>
    </>
  );
};
